import React from 'react';
import { isAuthenticated } from '../utils/auth';
import Navbar from './Navbar';
import PublicNavbar from './PublicNavbar';

/**
 * SmartNavbar - Renders the appropriate navbar based on authentication status
 * - If logged in: Shows authenticated Navbar with Dashboard, Settings, Logout
 * - If not logged in: Shows PublicNavbar with Login, Register buttons
 */
export default function SmartNavbar() {
  return isAuthenticated() ? <Navbar /> : <PublicNavbar />;
}
